import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CstmNotificationBarComponent } from 'app/shared/cstm-notification-bar/cstm-notification-bar.component';
import { MatDialog } from '@angular/material/dialog';
import { CustomDialougeBox } from 'app/shared/dailog_box/custom_dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { DocViewerComponent } from 'app/shared/doc-viewer/doc-viewer.component';
import { HdfcPaymentGatewayComponent } from 'app/shared/payment-gateway/hdfc-payment-gateway/hdfc-payment-gateway.component';
import * as _ from 'lodash';
@Injectable({
  providedIn: 'root'
})

export class ApiService {

  USER_PERMISSIONS = { "slct_in": 0, "insrt_in": 0, "updt_in": 0, "dlte_in": 0, "exprt_in": 0 };
  private _baseURL: string = environment.apiOrigin + '/apiv1/';

  // private readonly cstmAlrtMsgObj: ReplaySubject<any> = new ReplaySubject<any>(null);
  private atchmntdtls = new BehaviorSubject<any>(null);
  private closedta = new BehaviorSubject<any>(null);
  private setquilldta = new BehaviorSubject<any>(null);
  private setuProfiles = new BehaviorSubject<any>(null);
  private menuitems = new BehaviorSubject<any>(null);
  private subSidenav = new BehaviorSubject<any>(null);



  public cstmAlrtMsgObj: BehaviorSubject<any>;
  public lctnAddLstnr: ReplaySubject<any> = new ReplaySubject<any>(null);
  public postion: ReplaySubject<any> = new ReplaySubject<any>(null);
  public Tckt_id: ReplaySubject<any> = new ReplaySubject<any>(null);
  public Cntrctr_dta: ReplaySubject<any> = new ReplaySubject<any>(null);
  public Pswrddtls: ReplaySubject<any> = new ReplaySubject<any>(null);
  public setTcktfltr: ReplaySubject<any> = new ReplaySubject<any>(null);
  public setClntvalue: ReplaySubject<any> = new ReplaySubject<any>(null);
  public sbmnulst: ReplaySubject<any> = new ReplaySubject<any>(null);
  public ActMnu: ReplaySubject<any> = new ReplaySubject<any>(null);
  public SprtTckt_id: ReplaySubject<any> = new ReplaySubject<any>(null);
  public prfledtls: ReplaySubject<any> = new ReplaySubject<any>(null);
  private crncyFrmt = new BehaviorSubject<any>(null);
  showLoading: any;
  public cstmHdrDtls: BehaviorSubject<any>;
  bnrDtls = null;
  lgnUsrDtls = null;

  private feedSideNavTgle = new BehaviorSubject<any>(null);
  private showMainHeader = new BehaviorSubject<boolean>(true);

  constructor(private http: HttpClient, private _snackBar: MatSnackBar, private _matDialog: MatDialog) {
    this.cstmAlrtMsgObj = new BehaviorSubject(null);
    this.cstmHdrDtls = new BehaviorSubject(null);
  }

  // ----------------------------------
  create(postdata, rte) {
    return this.http.post(this._baseURL + `${rte}`, { data: postdata });
  }
  post(postdata, rte) {
    return this.http.post(this._baseURL + `${rte}`, postdata);
  }
  get(rte) {

    return this.http.get(this._baseURL + `${rte}`);
  }

  update(postdata, rte) {
    return this.http.put(this._baseURL + `${rte}`, { data: postdata });
  }

  put(postdata, rte) {
    return this.http.put(this._baseURL + `${rte}`, { data: postdata });
  }

  delete(rte) {
    return this.http.delete(this._baseURL + `${rte}`);
  }
  setPositions(pst_id, dprt_id) {
    this.postion.next({
      pst_id: pst_id,
      dprt_id: dprt_id
    });
  }
  getPositions() {
    return this.postion.asObservable();
  }




  showDailogeBox(title, body, btns_lst: Array<Object>, clbk) {
    let width = '400px';
    let height = '200px';
    let data = {
      title: title,
      body: body,
      btns_lst: btns_lst
    }
    const dialogRef = this._matDialog.open(CustomDialougeBox, {
      disableClose: true,
      width: width,
      height: height,
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
      clbk(result);
    });
  }

  shwAlrtMsg(type, title, body, drn?) {
    this.openNotification(type, title, body)
  }
  setLctnAddLstn(type, id) {
    this.lctnAddLstnr.next({
      type: type,
      id: id
    })
  }
  setSubMnuLst(sbmnus) {
    this.sbmnulst.next(sbmnus)
  }
  getSubMnuLst(): Observable<any> {
    return this.sbmnulst.asObservable();
  }

  setFeedSideNavTgle(thm) {
    this.feedSideNavTgle.next(thm)
  }
  getFeedSideNavTgle(): Observable<any> {
    return this.feedSideNavTgle.asObservable();
  }

  setShowMainHeader(enbl) {
    this.showMainHeader.next(enbl)
  }
  getShowMainHeader(): Observable<any> {
    return this.showMainHeader.asObservable();
  }

  setActMnu(sbmnus) {
    this.ActMnu.next(sbmnus)
  }
  getActMnu(): Observable<any> {
    return this.ActMnu.asObservable();
  }

  getLctnAddLstn(): Observable<any> {
    return this.lctnAddLstnr.asObservable();
  }

  setTcktId(type, data) {
    this.Tckt_id.next({
      type: type,
      id: data
    })
  }
  getTcktId(): Observable<any> {
    return this.Tckt_id.asObservable();
  }




  setCntrctrDta(dta) {
    console.log(dta)
    this.Cntrctr_dta.next({
      data: dta
    })
  }
  getCntrctrDta(): Observable<any> {
    return this.Cntrctr_dta.asObservable();
  }






  setTcktCnts(type, data) {
    this.Tckt_id.next({
      type: type,
      id: data
    })
  }
  getTcktCnts(): Observable<any> {
    return this.Tckt_id.asObservable();
  }

  setTcktfltrs(data) {
    this.setTcktfltr.next(data)
  }

  getTcktfltrs(): Observable<any> {
    return this.setTcktfltr.asObservable();
  }

  getupdtprfle(data) {
    console.log(data)
    this.prfledtls.next(data)
  }

  setupdtprfle(): Observable<any> {
    console.log(this.prfledtls)
    return this.prfledtls.asObservable();
  }

  setclntvalue(data) {
    this.setClntvalue.next(data)
  }

  getclntvalue(): Observable<any> {
    return this.setClntvalue.asObservable();
  }




  setSprtTcktCnts(type, data) {
    this.SprtTckt_id.next({
      type: type,
      id: data
    })
  }
  getSprtTcktCnts(): Observable<any> {
    return this.SprtTckt_id.asObservable();
  }



  getBannerDtls() {

    return new Promise((resolve, reject) => {
      if (this.bnrDtls) {
        resolve(this.bnrDtls);
      }
      else {
        let banner_dtls = JSON.parse(localStorage.getItem("banner_dtls"));
        if (banner_dtls) {
          this.bnrDtls = banner_dtls;
        }
        resolve(this.bnrDtls);
      }
    });
  }

  getLgnUsrHyrchyDtls() {
    let usr_obj = {
      usr_id: null,
      hyrchy_id: null,
      hyrchy_ky: null,
      hyrchy_nm: "",
      ste_id: null,
      dstrt_id: null,
      mndl_id: null,
      ulb_id: null,
      svm_id: null,
      rle_id: null,
      ulb_nm: "",
      svm_nm: "",
      hyrchy_hndlr_tx: "",
    };

    return new Promise((resolve, reject) => {
      if (this.lgnUsrDtls) {
        resolve(this.lgnUsrDtls);
      }
      else {
        let usrdtls = JSON.parse(localStorage.getItem("userdata"));
        if (usrdtls) {
          usr_obj["usr_id"] = usrdtls["usr_id"];
          usr_obj["hyrchy_id"] = usrdtls["hyrchy_id"];
          usr_obj["hyrchy_ky"] = usrdtls["hyrchy_ky"];
          usr_obj["hyrchy_nm"] = usrdtls["hyrchy_nm"];
          usr_obj["dstrt_id"] = usrdtls["dstrt_id"];
          usr_obj["mndl_id"] = usrdtls["mndl_id"];
          usr_obj["ulb_id"] = usrdtls["ulb_id"];
          usr_obj["svm_id"] = usrdtls["svm_id"];
          usr_obj["rle_id"] = usrdtls.roles["rle_id"];
          usr_obj["ulb_nm"] = usrdtls["ulb_nm"];
          usr_obj["svm_nm"] = usrdtls["svm_nm"];
          usr_obj["dstrt_nm"] = usrdtls["dstrt_nm"];
          usr_obj["ste_nm"] = usrdtls["ste_nm"];

          usr_obj["rle_nm"] = usrdtls['roles']["rle_nm"];
          usr_obj["rl_hdlr_tx"] = usrdtls['roles']["rl_hdlr_tx"];
          usr_obj["gp_id"] = usrdtls["gp_id"];
          usr_obj["gp_nm"] = usrdtls["gp_nm"];
          usr_obj["mndl_nm"] = usrdtls["mndl_nm"];
          usr_obj["dprt_id"] = usrdtls["dprt_id"];
          usr_obj["dprt_nm"] = usrdtls["dprt_nm"];
          usr_obj["dprt_cd"] = usrdtls["dprt_cd"];
          usr_obj["hyrchy_hndlr_tx"] = usrdtls['roles']["hyrchy_hndlr_tx"];

        }
        this.lgnUsrDtls = usrdtls;
        resolve(this.lgnUsrDtls);
      }

    });
  }


  getBlobType(rte) {
    console.log("GET route ::" + rte)
    if (rte.indexOf("http") > -1) {
      return this.http.get(`${rte}`, { responseType: 'blob' });
    } else {
      return this.http.get(`/${rte}`, { responseType: 'blob' });
    }
  }
  getConcatServerFilePath(fle_url) {
    var url = fle_url;
    var fl_splt = fle_url.split('/');
    let srvr_url = '';
    if (fl_splt && fl_splt.length) {
      if (fl_splt[0] == '') {
        srvr_url = `${environment.apiOrigin}${url}`
      }
      else {
        srvr_url = `${environment.apiOrigin}/${url}`
      }
    }

    return srvr_url;
  }

  openNotification(ntftn_type: string = 'primary', title, body, duration: number = 1000) {
    let data = {
      type: ntftn_type,
      title: title,
      body: body
    }
    this._snackBar.openFromComponent(CstmNotificationBarComponent, {
      data: data,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      duration: duration
    });
  }

  shwCstmHdr(hdr_dtls: {
    shw_hdr: boolean,
    title: string,
    shw_fltr: boolean,
    fltr_jsn: []
  }, clb_res) {
    hdr_dtls['fltr_clbk_res'] = clb_res;
    this.cstmHdrDtls.next(hdr_dtls)
  }

  getCstmHdr(): Observable<any> {
    return this.cstmHdrDtls.asObservable();
  }



  setdialougedta(e) {
    console.log(e)
    this.atchmntdtls.next(e);
    this.closedta.next(null)
  }

  getdialougedta() {
    return this.atchmntdtls.asObservable();
  }

  setclosedta() {
    this.closedta.next('close')
  }

  getclosedta() {
    return this.closedta.asObservable();
  }

  setquilldtas(data) {
    this.setquilldta.next(data)
  }
  getquilldtas() {
    return this.setquilldta.asObservable()
  }


  setSetupProfiles = (data: any) => {
    this.setuProfiles.next(data);

  }

  getSetupProfiles = (): Observable<any[]> => {
    return this.setuProfiles.asObservable()

  }


  public openSubSidenav() {
    this.subSidenav.next('open');
  }


  public closeSubSidenav() {
    this.subSidenav.next('close');
  }

  public getSubSidenav(): Observable<any[]> {
    return this.subSidenav.asObservable();
  }

  setPswrddtls(data) {
    this.Pswrddtls.next({
      datas: data
    })
  }
  getPswrddtls(): Observable<any> {
    return this.Pswrddtls.asObservable();
  }

  shwDocumentViewer(dcURL) {


    let width = '70%';
    let height = '70%';
    let data = {
      dcURL: dcURL,
    }
    const dialogRef = this._matDialog.open(DocViewerComponent, {
      disableClose: true,
      width: width,
      height: height,
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {

    });


  }


  iniitPaymentGatewayPage(pymnt_dtls, clbk) {
    let width = '800px';
    let height = '530px';
    let data = {
      pymnt_dtls: pymnt_dtls,
    }
    const dialogRef = this._matDialog.open(HdfcPaymentGatewayComponent, {
      disableClose: true,
      width: width,
      height: height,
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
      clbk(result);
    });
  }

  transform(value: number, unit: string): object {
    if (value == null) return { number: 0, suffix: '' };

    // Convert the amount based on the specified unit
    let convertedValue = _.cloneDeep(value);
    let suffix = '';

    switch (unit) {
      case 'crores':
        convertedValue = value / 10000000;
        suffix = ' Cr';
        break;
      case 'lakhs':
        convertedValue = value / 100000;
        suffix = ' L';
        break;
      case 'rupees':
        convertedValue = value;
        suffix = ' rs';
        break;
      case 'count':
        convertedValue = value;
        suffix = '';
        break;
    }

    // Format the converted value as Indian currency
    return { number: this.formatIndianCurrency(convertedValue, unit), suffix: suffix };
  }

  private formatIndianCurrency(amount: number, unit): string {
    if (unit == 'count') {
      const formatter = new Intl.NumberFormat('en-IN', {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });

      return formatter.format(amount);

    }
    else {
      const formatter = new Intl.NumberFormat('en-IN', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return formatter.format(amount);

    }
  }




  setCrncyFrmt(data) {
    this.crncyFrmt.next(data)
  }

  getCrncyFrmt(): Observable<any> {
    return this.crncyFrmt.asObservable();
  }

}
